import useLocalForage from "hooks/useLocalForage";
import React from "react";
import Draggable, { PositionOffsetControlPosition } from "react-draggable";
import {
  Button,
  Divider,
  Form,
  Icon,
  Segment,
  TextArea,
} from "semantic-ui-react";
import downloadTextFile from "utils/downloadTextFile";

interface NotepadProps {
  visible?: boolean;
  offset?: PositionOffsetControlPosition;
}

export const Notepad: React.FC<NotepadProps> = ({
  visible = true,
  offset = { x: "0%", y: "0%" },
}) => {
  const [notes, setNotes] = useLocalForage("notepad", "", 250);

  return (
    <Draggable cancel="form" bounds="html" positionOffset={offset}>
      <Segment
        className="notepad"
        style={{
          position: "fixed",
          zIndex: 999,
          display: visible ? "block" : "none",
          minWidth: "350px",
          minHeight: "350px",
          width: "20vw",
        }}
      >
        <strong>
          <Icon name="move" />
          Notepad
        </strong>
        <Divider />
        <Form>
          <TextArea
            placeholder="#todo: Add notes (they will automatically be saved in your browser)"
            style={{ minHeight: "250px", maxHeight: "50vh" }}
            // @ts-ignore
            value={notes}
            // @ts-ignore
            onChange={e => setNotes((e.target as HTMLInputElement).value)}
          />
        </Form>
        <Divider />
        <Button
          onClick={() => downloadTextFile(notes)}
          size="small"
          icon="download"
          title="Download notes"
        ></Button>
      </Segment>
    </Draggable>
  );
};

export default Notepad;
